import { matchesApiFlag } from '../../../utils/apiValues';
import { React, Fragment, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import "./Shared.scss";
import "../../../shades/Bucket.scss";
import TopBarPublic from "../TopbarPublic/TopbarPublic";




import linkIcon from "../../../assets/icons/linksicon.svg";


import LandingPage from "../../../assets/images/landingPage.png";
import LandingPageNoPreview from "../../../assets/images/Landing-page-No-preview-image.png";
import PurpleLink from "../../../assets/icons/purpleLink.svg";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import parse from "html-react-parser";
import twitterlogo from "../../../assets/images/twitternewlogo.svg";
import FbIcon from "../../../assets/images/facebook-svgrepo-com.svg";
import ZimzeeIcon from "../../../assets/icons/logoSymbol.svg";
import FullScreen from "../../../assets/icons/FullScreen.svg";
import RegionalScreen from "../../../assets/icons/RegionalScreenshot.svg";
import Highlight from "../../../assets/icons/HighlightText.svg";
import youtubeIcon from "../../../assets/images/youtube.svg";
import tiktokIcon from "../../../assets/images/download-tiktok.png";
import instagramIcon from "../../../assets/images/instagram-icon-png.png";
import defaultUser from "../../../assets/images/default-user.png";
import BookmarkPreview from "../../../assets/icons/bookmarksPreviews.svg";
import resizeIcon from "../../../assets/icons/resizeIcon.svg";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import SliderPopup from "../../../shades/cards/Sliderpopup";
import { toastify } from "../../../components/Toast";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BookmarkDetailIcon from "../../../assets/icons/bookmarkdetail.svg";
import "../../../shades/cards/Paragraph";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import useAnonymousIntercom from "../../intercom/useAnonymousIntercom";
import { Roller } from "react-awesome-spinners";
function Shared() {
  const [subBucket, setSubBucket] = useState({});
  const cardId = useParams();
  const [isPlaying, setIsPlaying] = useState(false);
  const [code, setCode] = useState("");
  const [tags, setTags] = useState([]);
  const [imageUrlPopup, setimageUrlPopup] = useState("");
  const [bookmarkhandlePopup, setBookmarkhandlePopup] = useState(false);
  const [isPlayingPopup, setIsPlayingPopup] = useState(false);
  const [popup, setPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [sourceUrl, setSourceUrl] = useState("");
  const [loading, ] = useState(true);
  const [imageSrc, setImageSrc] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;
    const previousTitle = document.title;
    const description = document.querySelector('meta[name="description"]');
    const previousDescription = description?.getAttribute('content');
    let image = document.querySelector('meta[property="og:image"]');
    const createdImage = !image;
    if (!image) {
      image = document.createElement('meta');
      image.setAttribute('property', 'og:image');
      document.head.appendChild(image);
    }
    const previousImage = image.getAttribute('content');
    document.title = 'Shared by Zimzee';
    description?.setAttribute('content', 'Your easy solution to save, organize, Recall and Collaborate EVERYTHING important to you.  Save an ad, a video clip, full page screenshot, text, Youtube, Facebook');
    image.setAttribute('content', 'https://statics.myclickfunnels.com/image/359988/file/1e07450180ca2b5a666dc018c2a3a26a.png');
    return () => {
      document.title = previousTitle;
      if (description && previousDescription !== null) description.setAttribute('content', previousDescription);
      if (createdImage) image.remove();
      else if (previousImage !== null) image.setAttribute('content', previousImage);
    };
  }, [isLoading]);

  useEffect(() => {
    let active = true;
    const fetchImage = async () => {
      if (subBucket?.landingPage?.status === true && subBucket?.landingPage?.url) {
        const exists = await checkImageExistence(subBucket?.landingPage?.url);
        if (active) setImageSrc(exists ? subBucket?.landingPage?.url : LandingPageNoPreview);
      } else if (subBucket?.landingPage?.status === false && subBucket?.landingPage?.sourceUrl) {
        // setImageSrc(LandingPage);
      } else {
        setImageSrc(LandingPageNoPreview);
      }
    };
    if(subBucket?.landingPage){
      fetchImage();
    }
    return () => { active = false; };
  }, [subBucket?.landingPage]);

  useAnonymousIntercom();
  useEffect(() => {
    // This request belongs to the current route/filter; ignore responses after cleanup.
    let active = true;
    const controller = new AbortController();
    let redirectTimer;

    const publicShared = async () => {
      try {
        setIsLoading(true);
        await axios
          .get(`${process.env.REACT_APP_API}cards/public-shared/${cardId.id}`, { signal: controller.signal })
          .then(function (response) {
            if (!active) return;
            const card = response?.data?.data;
            if (!card || typeof card !== 'object' || Array.isArray(card)) {
              throw new Error('Invalid public card response');
            }
            setIsLoading(false);
            setSubBucket(card);
            setCode(card.note ?? '');
            setSourceUrl(card.content?.sourceUrl ?? '');
            setTags(Array.isArray(card.tags) ? card.tags : []);
          });
        if (!active) return;
      } catch (error) {
        if (!active || controller.signal.aborted) return;
        redirectTimer = setTimeout(() => navigate('/expiry'), 1000);
        console.error(error);
      }
    };

    const getBrowserId = () => {
      // Implement your logic to generate or retrieve a unique browser ID
      // For example, you might use a combination of user agent and some randomization
      const userAgent = navigator.userAgent;
      const randomPart = Math.random().toString(36).substring(2, 15);
      const browserId = `${userAgent}_${randomPart}`;

      return browserId;
    };

    const StarredCard = async () => {
      const token = localStorage.getItem("token");
      try {
        await axios.patch(
          `${process.env.REACT_APP_API}cards/updateSharedCard-engagements`,
          { cardId: cardId.id, views: 1 },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!active) return;
      } catch (error) {
        console.error(error);
      }
    };
    const browserId = getBrowserId();
    if (
      !localStorage.getItem("browserId") &&
      !localStorage.getItem("sharedCardId")
    ) {
      localStorage.setItem("browserId", browserId);
      localStorage.setItem("sharedCardId", cardId.id);
      localStorage.getItem("token");
      StarredCard();
    } else {
      const sharedCardId = localStorage.getItem("sharedCardId");
      if (cardId.id !== sharedCardId) {
        localStorage.setItem("sharedCardId", cardId.id);
        StarredCard();
      }
    }
    publicShared();

    return () => {
      active = false;
      controller.abort();
      clearTimeout(redirectTimer);
    };
  }, [cardId.id, navigate]);

  const handleCardClickRequest = async () => {
    const token = localStorage.getItem("token");
    try {
      await axios.patch(
        `${process.env.REACT_APP_API}cards/updateSharedCard-engagements`,
        { cardId: cardId.id, clicks: 1 },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error(error);
    }
  };



  const handleCardLink = async () => {
    const url = window.location.href;
    if (url) {
      // Create a temporary input element to copy the link to clipboard
      const tempInput = document.createElement("input");
      tempInput.value = url;

      // Append the input element to the DOM
      document.body.appendChild(tempInput);

      // Select the input element's text and copy it to clipboard
      tempInput.select();
      document.execCommand("copy");

      // Remove the temporary input element
      document.body.removeChild(tempInput);

      // Optionally, you can show a message to indicate that the link has been copied
      toastify("success", "Public link is copied to clipboard");
    }
  };

  const handlePopup = () => {
    setPopup(true);
    setIsPlayingPopup(false);
  };

  const handlePlayVideoPopup = (event) => {
    // document.querySelector('video').play();
    if (isPlayingPopup) {
      document.querySelector(".bucketCreationPopup video").pause();
    } else {
      document.querySelector(".bucketCreationPopup video").play();
    }
    setIsPlayingPopup(!isPlayingPopup);
    event.stopPropagation();
  };

  function closePopup() {
    setPopup(false);
  }

  const handleImageClick = (imageUrl) => {
    setimageUrlPopup(imageUrl);
    setBookmarkhandlePopup(true);
  };

  function closebookmarkPopup() {
    setBookmarkhandlePopup(false);
  }

  const handleChildClick = (event) => {
    event.stopPropagation();
  };

  const handlePlayVideo = (event) => {
    // document.querySelector('video').play();
    if (isPlaying) {
      document.querySelector(".video-content-inner video").pause();
    } else {
      document.querySelector(".video-content-inner video").play();
    }
    setIsPlaying(!isPlaying);
    event.stopPropagation();
  };

  const handleSignup = async () => {
    const token = localStorage.getItem("token");
    try {
      await axios.patch(
        `${process.env.REACT_APP_API}cards/updateSharedCard-engagements`,
        { cardId: cardId.id, clicks: 1 },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // navigate("/signup");
      window.open("/signup", "_blank");
    } catch (error) {
      console.error(error);
      window.open("/signup", "_blank");
    }
  };
  async function checkImageExistence(url) {
    return new Promise(async (resolve) => {
      try {
        var img = new Image();
        img.onload = function () {
          resolve(true);
        };
        img.onerror = function () {
          resolve(false);
        };
        img.src = url;
      } catch (error) {
        console.error("Error checking image existence:", error);
        resolve(false);
      }
    });
  }
  let videoIframe = "";
  let videoIframePopup = "";
  if (
    subBucket?.content?.imageUrl.length > 0 &&
    subBucket?.content?.imageUrl[0].urlType === "Video" &&
    subBucket?.content?.html &&
    subBucket?.content?.imageUrl[0].url
  ) {
    videoIframe = subBucket?.content?.html;
    const tempElement = document.createElement("div");
    tempElement.innerHTML = videoIframe;
    // tempElement.find('iframe').attr('')
    const iframes = tempElement.querySelector("iframe");
    if (iframes) {
      const videoElement = document.createElement("video");
      videoElement.controls = isPlaying ? true : false;
      // videoElement.autoplay = true;

      const sourceElement = document.createElement("source");
      sourceElement.src = subBucket?.content?.imageUrl[0].url;
      sourceElement.type = "video/mp4";

      videoElement.appendChild(sourceElement);
      const playIcon = document.createElement("div");
      playIcon.className = "play-icon";
      playIcon.innerHTML = "&#9658;";

      // Wrap the video element with a container div
      const videoContainer = document.createElement("div");
      videoContainer.className = "video-container";
      videoContainer.appendChild(videoElement);
      // videoContainer.appendChild(playIcon);

      // Replace the iframe with the video element
      iframes.parentNode.replaceChild(videoContainer, iframes);
      // const myTimeout = setTimeout(myStopFunction, 1000);

      //     function myStopFunction() {
      //         setIsVideoHeight(document.getElementsByTagName('video')[0].clientHeight);
      //     }
    }

    // Get the updated HTML content from the temporary container
    const updatedHtml = tempElement.innerHTML;
    videoIframe = updatedHtml;

    videoIframePopup = subBucket?.content?.html;
    const tempElementPopup = document.createElement("div");
    tempElementPopup.innerHTML = videoIframePopup;
    // tempElement.find('iframe').attr('')
    const iframesPopup = tempElementPopup.querySelector("iframe");
    if (iframesPopup) {
      const videoElementPopup = document.createElement("video");
      // videoElementPopup.controls = isPlayingPopup ? true : false;
      // videoElement.autoplay = true;

      const sourceElementPopup = document.createElement("source");
      sourceElementPopup.src = subBucket?.content?.imageUrl[0].url;
      sourceElementPopup.type = "video/mp4";

      videoElementPopup.appendChild(sourceElementPopup);
      // Wrap the video element with a container div
      const videoContainerPopup = document.createElement("div");
      videoContainerPopup.className = "video-container";
      videoContainerPopup.appendChild(videoElementPopup);
      // videoContainer.appendChild(playIcon);

      // Replace the iframe with the video element
      iframesPopup.parentNode.replaceChild(videoContainerPopup, iframesPopup);
    }

    // Get the updated HTML content from the temporary container
    const updatedHtmlPopup = tempElementPopup.innerHTML;
    videoIframePopup = updatedHtmlPopup;
  }

  return (
    <>
      {isLoading ? (
        <div className="App-loading">
          <div className="App-logo" title="Zimzee" />
        </div>
      ) : (
        <div>
          <TopBarPublic />
          <div className="publicshare-section">
            <ToastContainer />
            <div className="flex publicspace-content">
              <div className="publicdesc-content">
                <span>
                  {subBucket?.sharedItems
                    ? subBucket?.sharedItems[0]?.sharedBy?.firstName
                    : ""}{" "}
                  {subBucket?.sharedItems
                    ? subBucket?.sharedItems[0]?.sharedBy?.lastName
                    : ""}
                </span>{" "}
                shared this card using Zimzee.com
              </div>
              <div className="buttonpublic-content">
                <div className="flex items-center	">
                  <img
                    className="topinner-logo mr-[16px]"
                    src={
                      subBucket?.cardType
                        ? subBucket.cardType === "twitter"
                          ? twitterlogo
                          : subBucket.cardType === "facebook" ||
                            subBucket.cardType === "Facebook"
                          ? FbIcon
                          : subBucket.cardType === "screenshoot"
                          ? ZimzeeIcon
                          : subBucket.cardType === "fullScreen"
                          ? FullScreen
                          : subBucket.cardType === "partScreen"
                          ? RegionalScreen
                          : subBucket.cardType === "highlightText"
                          ? Highlight
                          : subBucket.cardType === "youtube"
                          ? youtubeIcon
                          : subBucket.cardType === "TikTok"
                          ? tiktokIcon
                          : subBucket.cardType === "instagram"
                          ? instagramIcon
                          : subBucket.cardType === "bookmark"
                          ? BookmarkDetailIcon
                          : defaultUser
                        : ""
                    }
                    alt="Icon"
                    style={{ cursor: "default" }}
                  />
                  <button
                    style={{
                      filter: "drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.161))",
                    }}
                    onClick={handleSignup}
                    className="buttonpadding-content text-[16px] rounded-full bg-[#FF6600] text-white"
                  >
                    <span className="savebutton-context">Sign Up</span>
                  </button>
                </div>
              </div>
            </div>
            <div className="cardHeaderDetails flex">
              {/* <div className="display-content">                   
            <ul className="flex flex-wrap items-center">
              <li className="text-[14px] lg:text-[17px]"><a className="flex items-center" href="/"><img src={CalenderIcon} alt='calenderIcon' className="w-[22px]"/> <span className="createdtext-content pl-2">Created Jan 5, 2022 @ 05:00 AM</span></a> </li>
            </ul>
          </div> 
          <div className="display-content">                   
            <ul className="flex flex-wrap items-center">
              <li className="text-[14px] lg:text-[17px]"><a className="flex items-center" href="/"><img src={CalenderIcon} alt='calenderIcon' className="w-[22px]"/> <span className="createdtext-content pl-2">Last updated on Jan 5, 2022 @ 4:30 PM</span></a> </li>
            </ul>
          </div> */}
              {/* <img className="mr-[7px] next-icons" src={PreviousIcon} alt="PreviousIcon"/>
          <img className="ml-[7px] next-icons" src={NextIcon} alt="NextIcon"/> */}
            </div>
            <div className="carddetail" onClick={handleCardClickRequest}>
              <div className="secondsections-content flex">
                <div className="cardData cardtextwhole-content w-2/3 sm:w-full width-50">
                  <div className="flex">
                    <img
                      className="mr-[5px] inner-logo border-rounded"
                      src={
                        subBucket?.cardType
                          ? subBucket.cardType === "twitter"
                            ? twitterlogo
                            : subBucket.cardType === "facebook" ||
                              subBucket.cardType === "Facebook"
                            ? subBucket.postDetail
                              ? subBucket.postDetail.imageUrl
                              : FbIcon
                            : subBucket.cardType === "screenshoot"
                            ? ZimzeeIcon
                            : subBucket.cardType === "fullScreen"
                            ? FullScreen
                            : subBucket.cardType === "partScreen"
                            ? RegionalScreen
                            : subBucket.cardType === "highlightText"
                            ? Highlight
                            : subBucket.cardType === "youtube"
                            ? subBucket.postDetail
                              ? subBucket.postDetail.imageUrl
                              : youtubeIcon
                            : subBucket.cardType === "TikTok"
                            ? tiktokIcon
                            : subBucket.cardType === "instagram"
                            ? subBucket.postDetail
                              ? subBucket.postDetail.imageUrl
                              : instagramIcon
                            : defaultUser
                          : ""
                      }
                      alt="Icon"
                    />
                    <span className="internetdesc-content">
                      {subBucket?.title}
                      <img
                        className="publiclink-imgcontent"
                        src={linkIcon}
                        alt="link-icon"
                        onClick={handleCardLink}
                      />
                    </span>
                    {subBucket.cardType === "bookmark" ? (
                      <a href={`${sourceUrl}`} target="_blank" rel="noopener noreferrer">
                        <span>
                          <img alt="Open source"
                            className="resizeicons-imgcontent"
                            src={resizeIcon}
                            style={{
                              width: "19px",
                              marginLeft: "14px",
                              paddingTop: "2px",
                            }}
                          />
                        </span>
                      </a>
                    ) : subBucket.cardType === "File" ? null : (
                      <span onClick={handlePopup}>
                        <img alt="Open card preview"
                          className="resizeicons-imgcontent ml-[40px]"
                          src={resizeIcon}
                          style={{ width: "20px" }}
                        />
                      </span>
                    )}
                  </div>
                  <div className="detail-content cardHtmlnew-content">
                    {subBucket?.content ? (
                      subBucket.content.imageUrl.length > 0 &&
                      subBucket?.content?.imageUrl[0].urlType === "Image" &&
                      subBucket.content.html ? (
                        <div className="share-cardContent">
                          <div className="cardContent cardDetailContent">
                            <div className="cardImage w-full  atest">
                              {subBucket?.cardType ? (
                                subBucket.cardType === "twitter" ? (
                                  parse(subBucket.content.html)
                                ) : subBucket.cardType === "facebook" ? (
                                  subBucket?.content?.imageUrl[0]
                                    .isAdLibrary ? (
                                    <>
                                      <div className="ad-lib-first-html">
                                        {parse(subBucket.content.html)}
                                      </div>
                                    </>
                                  ) : (
                                    <div className="shared-first-html">
                                      {parse(subBucket.content.html)}
                                    </div>
                                  )
                                ) : (
                                  ""
                                )
                              ) : (
                                ""
                              )}

                              <div
                                className={`container fb-image ${
                                  subBucket?.cardType === "youtube"
                                    ? "youtube-container"
                                    : ""
                                }`}
                              >
                                {subBucket?.content?.imageUrl.length > 0 &&
                                subBucket?.content?.imageUrl[0].urlType ===
                                  "Image" &&
                                subBucket?.cardType !== "youtube" ? (
                                  subBucket.cardType === "bookmark" ? (
                                    <a
                                      href={`${subBucket?.content?.sourceUrl}`}
                                      target="_blank"
                                     rel="noopener noreferrer">
                                      <img
                                        className="w-full dgdg"
                                        src={
                                          subBucket?.content?.imageUrl[0].url
                                        }
                                        alt="Card preview"
                                      />
                                    </a>
                                  ) : (
                                    <img
                                      className="w-full dgdg"
                                      src={subBucket?.content?.imageUrl[0].url}
                                      alt="Card preview"
                                      onClick={handlePopup}
                                    />
                                  )
                                ) : subBucket?.cardType === "youtube" ? (
                                  <iframe title="YouTube video"
                                    src={
                                      `https://www.youtube.com/embed/` +
                                      subBucket?.content?.sourceUrl
                                        .split("v=")[1]
                                        .split("&")[0]
                                    }
                                    width="560"
                                    height="315"
                                  ></iframe>
                                ) : (
                                  ""
                                )}
                              </div>
                              {subBucket?.cardType ? (
                                subBucket.cardType === "twitter" ? (
                                  ""
                                ) : subBucket.cardType === "facebook" ? (
                                  subBucket?.content?.imageUrl[0]
                                    .isAdLibrary ? (
                                    <>
                                      <div className="ad-lib-second-html">
                                        {parse(subBucket?.content?.html)}
                                      </div>
                                    </>
                                  ) : (
                                    <div className="shared-second-html">
                                      {parse(subBucket?.content?.html)}
                                    </div>
                                  )
                                ) : (
                                  ""
                                )
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      ) : subBucket?.content?.imageUrl.length > 0 &&
                        subBucket?.content?.imageUrl[0].urlType === "Video" &&
                        subBucket?.content?.html === " " ? (
                        <div
                          className={`cardContent cardDetailContent video video-content-inner ${
                            isPlaying ? "active" : ""
                          }`}
                        >
                          {parse(subBucket?.content?.html)}

                          {/* {parse(videoIframe)} */}
                          <div className="video-container">
                            {isPlaying ? (
                              <video controls>
                                <source
                                  src={subBucket?.content?.imageUrl[0].url}
                                ></source>
                              </video>
                            ) : (
                              <video>
                                <source
                                  src={subBucket?.content?.imageUrl[0].url}
                                ></source>
                              </video>
                            )}

                            {isPlaying ? (
                              // <FontAwesomeIcon className="ml-[40px] text-[#989898]" icon={faPause} style={{color:"#fff",fontSize:"40px"}}/>
                              ""
                            ) : subBucket?.content?.imageUrl[0]?.url ? (
                              <>
                                <div
                                  className="toggle-view-icon-outer"
                                  onClick={handlePlayVideo}
                                >
                                  <div className="toggle-view-icon">
                                    <FontAwesomeIcon
                                      className="ml-[40px] text-[#989898]"
                                      icon={faPlay}
                                      style={{
                                        color: "#111111b0",
                                        fontSize: "40px",
                                      }}
                                    />
                                  </div>
                                </div>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                          {/* <FontAwesomeIcon icon="fa-solid fa-play" /> */}

                          {subBucket?.cardType ? (
                            subBucket.cardType === "twitter" ? (
                              ""
                            ) : subBucket.cardType === "facebook" ? (
                              <div className="shared-second-html">
                                {parse(subBucket.content.html)}
                              </div>
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )}
                        </div>
                      ) : subBucket?.content?.imageUrl.length > 0 &&
                        subBucket?.content?.imageUrl[0].urlType === "Video" &&
                        subBucket.content.html ? (
                        <div
                          className={`cardContent cardDetailContent video video-content-inner ${
                            isPlaying ? "active" : ""
                          }`}
                        >
                          {subBucket?.cardType ? (
                            subBucket.cardType === "twitter" ? (
                              parse(subBucket.content.html)
                            ) : subBucket.cardType === "facebook" ? (
                              subBucket?.content?.imageUrl[0].isAdLibrary ? (
                                <>
                                  <div className="ad-lib-first-html">
                                    {parse(subBucket.content.html)}
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="shared-first-html">
                                    {parse(subBucket.content.html)}
                                  </div>
                                </>
                              )
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )}
                          {/* {parse(videoIframe)} */}

                          {subBucket?.content?.imageUrl[0]?.url ? (
                            <div className="video-container">
                              {isPlaying ? (
                                <video controls>
                                  <source
                                    src={subBucket?.content?.imageUrl[0].url}
                                  ></source>
                                </video>
                              ) : (
                                <video>
                                  <source
                                    src={subBucket?.content?.imageUrl[0].url}
                                  ></source>
                                </video>
                              )}

                              {isPlaying ? (
                                // <FontAwesomeIcon className="ml-[40px] text-[#989898]" icon={faPause} style={{color:"#fff",fontSize:"40px"}}/>
                                ""
                              ) : subBucket?.content?.imageUrl[0]?.url ? (
                                <>
                                  <div
                                    className="toggle-view-icon-outer"
                                    onClick={handlePlayVideo}
                                  >
                                    <div className="toggle-view-icon">
                                      <FontAwesomeIcon
                                        className="ml-[40px] text-[#989898]"
                                        icon={faPlay}
                                        style={{
                                          color: "#111111b0",
                                          fontSize: "40px",
                                        }}
                                      />
                                    </div>
                                  </div>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          ) : subBucket?.cardType === "youtube" ? (
                            <div className="youtube-container">
                              <iframe title="YouTube video"
                                src={
                                  `https://www.youtube.com/embed/` +
                                  subBucket?.content?.sourceUrl
                                    .split("v=")[1]
                                    .split("&")[0]
                                }
                                width="560"
                                height="315"
                              ></iframe>
                            </div>
                          ) : (
                            ""
                          )}

                          {/* <FontAwesomeIcon icon="fa-solid fa-play" /> */}
                          {subBucket?.cardType ? (
                            subBucket.cardType === "twitter" ? (
                              ""
                            ) : subBucket.cardType === "facebook" ? (
                              subBucket?.content?.imageUrl[0].isAdLibrary ? (
                                <>
                                  <div className="ad-lib-second-html">
                                    {parse(subBucket.content.html)}
                                  </div>
                                </>
                              ) : (
                                <div className="shared-second-html">
                                  {parse(subBucket.content.html)}
                                </div>
                              )
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )}
                        </div>
                      ) : subBucket.content.html ? (
                        <div className="cardContent cardDetailContent">
                          {subBucket.cardType === "bookmark" ? (
                            <a
                              href={`${subBucket?.content?.imageUrl?.url}`}
                              target="_blank"
                             rel="noopener noreferrer">
                              <img
                                className="w-full"
                                src={BookmarkPreview}
                                alt="Card preview"
                              />
                            </a>
                          ) : (
                            parse(subBucket.content.html)
                          )}
                        </div>
                      ) : (
                        <div className="cardContent cardDetailContent">
                          <div className="container fb-image cardImage w-full mt-6 btest">
                            {subBucket?.content?.imageUrl.length > 0 ? (
                              <img
                                className="w-full"
                                src={subBucket?.content?.imageUrl[0].url}
                                alt="Card preview"
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      )
                    ) : (
                      ""
                    )}
                  </div>
                  {/* <img className="cardDetailpublic-imgcontent" src={CardDetail} alt="CardDetail" /> */}
                  {/* <div className="inviteBtn">
                <div className="btncard-invite rounded-full bg-[#FFFFFF] text-white sm:text-sm  md:text-md lg:text-lg" href="#"><img className="mr-2" src={DownloadButton} alt="downloadButton" />JPG</div>
              </div> */}
                  <br />
                  <div className="flex">
                    {subBucket?.content ? (
                      subBucket.content.imageUrl.length > 1 &&
                      subBucket?.content?.imageUrl[0].urlType === "Image" ? (
                        <div>
                          <SliderPopup
                            images={subBucket.content.imageUrl}
                            handleImageClick={handleImageClick}
                          />
                        </div>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}

                    {/* <div>
                    <img
                      className="floatingmenu-imgcontent"
                      src={FloatingMenu}
                      alt="FloatingMenu"
                    />
                  </div> */}
                  </div>
                  {popup && (
                    <div
                      className="bucketCreationPopup relative !z-[999]"
                      style={{ height: "100%" }}
                      onClick={closePopup}
                    >
                      <form
                        className="addBucket public-sharepopup relative w-[85%] md:w-[55%]"
                        onClick={handleChildClick}
                      >
                        <span
                          onClick={closePopup}
                          className="cls-btn absolute right-0 top-[7px] w-[30px] h-[30px] bg-[#FF6600] flex justify-center items-center rounded-full"
                          style={{ zIndex: 1 }}
                        >
                          <FontAwesomeIcon
                            className="cursor-pointer text-white text-[20px]"
                            icon={faClose}
                          />
                        </span>
                        {subBucket?.content ? (
                          subBucket.content.imageUrl.length > 0 &&
                          subBucket?.content?.imageUrl[0].urlType === "Image" &&
                          subBucket.content.html ? (
                            <div
                              className="popup-img"
                              style={{ maxHeight: "100vh" }}
                            >
                              {/* {(subBucket?.cardType)? (subBucket.cardType == 'twitter' ?  
                                                        parse(subBucket.content.html)
                                                    : subBucket.cardType == 'facebook' ? 
                                                    <div className="first-html">
                                                        {parse(subBucket.content.html)}
                                                    </div>
                                                    : ""):("")} */}
                              {subBucket?.cardType ? (
                                subBucket.cardType === "twitter" ? (
                                  parse(subBucket.content.html)
                                ) : subBucket.cardType === "facebook" ? (
                                  subBucket?.content?.imageUrl[0]
                                    .isAdLibrary ? (
                                    <>
                                      <div className="ad-lib-first-html">
                                        {parse(subBucket.content.html)}
                                      </div>
                                    </>
                                  ) : (
                                    <div className="shared-first-html">
                                      {parse(subBucket.content.html)}
                                      {/* <Paragraphs
                                                                text={subBucket.content.html}
                                                                maxLength={380}
                                                            /> */}
                                    </div>
                                  )
                                ) : (
                                  ""
                                )
                              ) : (
                                ""
                              )}

                              {/* {
                                                            (subBucket?.content?.imageUrl.length > 0 && subBucket?.content?.imageUrl[0].urlType == 'Image')? (
                                                                <img className="w-full" src={subBucket?.content?.imageUrl[0].url} alt="card-image"/>
                                                            ) :("")
                                                        } */}

                              {subBucket?.content?.imageUrl.length > 0 &&
                              subBucket?.content?.imageUrl[0].urlType ===
                                "Image" &&
                              subBucket?.cardType !== "youtube" ? (
                                <img
                                  className="w-full"
                                  src={subBucket?.content?.imageUrl[0].url}
                                  alt="Card preview"
                                />
                              ) : subBucket?.cardType === "youtube" ? (
                                <iframe title="YouTube video"
                                  src={
                                    `https://www.youtube.com/embed/` +
                                    subBucket?.content?.sourceUrl
                                      .split("v=")[1]
                                      .split("&")[0]
                                  }
                                  width="100%"
                                  height="500px"
                                ></iframe>
                              ) : (
                                ""
                              )}

                              {subBucket?.cardType ? (
                                subBucket.cardType === "twitter" ? (
                                  ""
                                ) : subBucket.cardType === "facebook" ? (
                                  subBucket?.content?.imageUrl[0]
                                    .isAdLibrary ? (
                                    <>
                                      <div className="ad-lib-second-html">
                                        {parse(subBucket.content.html)}
                                      </div>
                                    </>
                                  ) : (
                                    <div className="shared-second-html">
                                      {parse(subBucket.content.html)}
                                    </div>
                                  )
                                ) : (
                                  ""
                                )
                              ) : (
                                ""
                              )}
                              {/* {(subBucket?.cardType)? (subBucket.cardType == 'twitter' ?  
                                                        ""
                                                    : subBucket.cardType == 'facebook' ? 
                                                        <div className="second-html">
                                                            {parse(subBucket.content.html)}
                                                        </div>
                                                    : ""):("")} */}

                              {/* {parse(subBucket.content.html)}
                                                    <img className="w-full" src={subBucket?.content?.imageUrl} alt="card-image" /> */}
                            </div>
                          ) : subBucket?.content?.imageUrl.length > 0 &&
                            subBucket?.content?.imageUrl[0].urlType ===
                              "Video" &&
                            subBucket.content.html ? (
                            <div
                              style={{ maxHeight: "100vh", overflow: "auto" }}
                            >
                              <div
                                className={`cardContent cardDetailContent video video-content-inner ${
                                  isPlayingPopup ? "active" : ""
                                }`}
                              >
                                {/* <Paragraphs
                                                        text={subBucket?.content?.html}
                                                        maxLength={380} /> */}

                                <div className="detail-page-see-data">
                                  <div className={`detail-text-wrapper active`}>
                                    {subBucket?.cardType ? (
                                      subBucket.cardType === "twitter" ? (
                                        parse(subBucket.content.html)
                                      ) : subBucket.cardType === "facebook" ? (
                                        subBucket?.content?.imageUrl[0]
                                          .isAdLibrary ? (
                                          <>
                                            <div className="ad-lib-first-html">
                                              {parse(subBucket.content.html)}
                                            </div>
                                          </>
                                        ) : (
                                          parse(subBucket.content.html)
                                        )
                                      ) : (
                                        ""
                                      )
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                                {/* {parse(subBucket?.content?.html)} */}
                                {subBucket?.content?.imageUrl[0]?.url ? (
                                  <div className="video-container">
                                    {isPlayingPopup ? (
                                      <video controls>
                                        <source
                                          src={
                                            subBucket?.content?.imageUrl[0].url
                                          }
                                        ></source>
                                      </video>
                                    ) : (
                                      <video>
                                        <source
                                          src={
                                            subBucket?.content?.imageUrl[0].url
                                          }
                                        ></source>
                                      </video>
                                    )}

                                    {isPlayingPopup ? (
                                      // <FontAwesomeIcon className="ml-[40px] text-[#989898]" icon={faPause} style={{color:"#fff",fontSize:"40px"}}/>
                                      ""
                                    ) : subBucket?.content?.imageUrl[0]?.url ? (
                                      <>
                                        <div
                                          className="toggle-view-icon-outer"
                                          onClick={handlePlayVideoPopup}
                                        >
                                          <div className="toggle-view-icon">
                                            <FontAwesomeIcon
                                              className="ml-[40px] text-[#989898]"
                                              icon={faPlay}
                                              style={{
                                                color: "#111111b0",
                                                fontSize: "40px",
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                ) : subBucket?.cardType === "youtube" ? (
                                  <div className="youtube-container">
                                    <iframe title="YouTube video"
                                      src={
                                        `https://www.youtube.com/embed/` +
                                        subBucket?.content?.sourceUrl
                                          .split("v=")[1]
                                          .split("&")[0]
                                      }
                                      width="560"
                                      height="315"
                                    ></iframe>
                                  </div>
                                ) : subBucket?.cardType === "facebook" &&
                                  subBucket?.content?.imageUrl[0]?.metaData ? (
                                  <div className="youtube-container">
                                    <iframe title="Embedded card content"
                                      src={
                                        subBucket?.content?.imageUrl[0]
                                          ?.metaData?.embedUrl
                                      }
                                      width="560"
                                      height="315"
                                    ></iframe>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {/* <FontAwesomeIcon icon="fa-solid fa-play" /> */}

                                {subBucket?.cardType ? (
                                  subBucket.cardType === "twitter" ? (
                                    ""
                                  ) : subBucket.cardType === "facebook" ? (
                                    subBucket?.content?.imageUrl[0]
                                      .isAdLibrary ? (
                                      <>
                                        <div className="ad-lib-second-html">
                                          {parse(subBucket.content.html)}
                                        </div>
                                      </>
                                    ) : (
                                      <div className="shared-second-html">
                                        {parse(subBucket.content.html)}
                                      </div>
                                    )
                                  ) : (
                                    ""
                                  )
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          ) : subBucket.content.html ? (
                            parse(subBucket.content.html)
                          ) : (
                            <div
                              style={{ maxHeight: "100vh", overflow: "auto" }}
                            >
                              {subBucket?.content?.imageUrl.length > 0 ? (
                                <img
                                  className="w-full"
                                  src={subBucket?.content?.imageUrl[0].url}
                                  alt="Card preview"
                                />
                              ) : (
                                ""
                              )}
                            </div>
                          )
                        ) : (
                          ""
                        )}
                      </form>
                    </div>
                  )}
                  {bookmarkhandlePopup && (
                    <div
                      className="bucketCreationPopup relative !z-[999]"
                      style={{ height: "100%" }}
                      onClick={closebookmarkPopup}
                    >
                      <form
                        className="addBucket relative w-[85%] md:w-[50%]"
                        onClick={handleChildClick}
                      >
                        <span
                          onClick={closebookmarkPopup}
                          className="cls-btn absolute right-0 top-[7px] w-[30px] h-[30px] bg-[#FF6600] flex justify-center items-center rounded-full"
                        >
                          <FontAwesomeIcon
                            className="cursor-pointer text-white text-[20px]"
                            icon={faClose}
                          />
                        </span>
                        <img
                          className="bookmarkspopup-content"
                          src={imageUrlPopup}
                          alt="bookmarksPopup"
                        />
                      </form>
                    </div>
                  )}
                </div>
                <div className="rightSideCardDetail w-1/3 pl-[30px] sm:pl-[15px] sm:w-full">
                  {code ? (
                    <>
                      <div className="notesHolder">
                        <h4 className="headingtext-content">Notes</h4>
                      </div>
                      <div className="notedescr-content">
                        <ReactQuill theme="snow" value={code} readOnly />
                      </div>
                    </>
                  ) : null}
                  {tags?.length ? (
                    <>
                      <h4 className="headingtext-content tagspace-notecontent">
                        Tags
                      </h4>
                      <div className="shared-tags flex">
                        {tags?.map((tag) => {
                          return (
                            <div className="addtagpublic-content">
                              {tag?.name}
                            </div>
                          );
                        })}
                      </div>
                    </>
                  ) : null}

                  {subBucket?.landingPage ? (
                    subBucket?.landingPage?.sourceUrl ? (
                      subBucket?.landingPage?.sourceUrl !== "" &&
                      subBucket?.landingPage?.sourceUrl !== "undefined" ? (
                        <>
                          <div className="landingpage-content">
                            Landing Page
                          </div>
                          <div className="flex">
                          <div className="sb-cap-scr">
                              {
                                matchesApiFlag(subBucket?.landingPage?.status, false) && subBucket?.landingPage?.sourceUrl ?
                                <div>
                                  <div class="loader-sb-cap-scr">
                                      {loading && <Roller color={`#FFFFFF`} />}
                                      <div className="loadingtext-content">loading...</div>
                                  </div>

                                </div>
                                : <a
                                href={
                                  matchesApiFlag(subBucket?.landingPage?.status, true) && subBucket?.landingPage?.url
                                      ? subBucket?.landingPage?.url
                                      : matchesApiFlag(subBucket?.landingPage?.status, false) && subBucket?.landingPage?.sourceUrl? LandingPage : LandingPageNoPreview
                                }
                                target="_blank"
                               rel="noopener noreferrer">
                                {
                                  imageSrc ?
                                  <img
                                    className="landing-imgcontent"
                                    alt="LandingPage"
                                    src={imageSrc}
                                  /> : ""
                                }
                              </a>
                              }

                            </div>
                          </div>
                          <div className="landing-cardcontent">
                            <a
                              href={subBucket?.landingPage?.sourceUrl}
                              target="_blank"
                             rel="noopener noreferrer">
                              <div className="purple-imgcontent">
                                <img
                                  className="pr-2"
                                  src={PurpleLink}
                                  alt="PurpleLink"
                                />
                                Visit Website
                              </div>
                            </a>
                          </div>
                        </>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default Shared;
